import z from "zod";
import { absenceCategories } from "../../absences";
import { moment } from "../../date";
import { localized } from "../../locales";

export const absenceFormSchema = z
	.object({
		category: z.enum(absenceCategories),
		absenceTypeId: z.uuid().nullable(),
		startDate: z.string(),
		endDate: z.string(),
		halfDayStart: z.boolean().default(() => false),
		halfDayEnd: z.boolean().default(() => false),
	})
	.superRefine((values, context) => {
		const startDate = moment(values.startDate);
		const endDate = moment(values.endDate);

		if (endDate.isBefore(startDate)) {
			context.addIssue({
				code: "custom",
				path: ["endDate"],
				message: localized("dates.end_date_cant_be_before_start_date"),
			});
		}
	});

export type AbsenceFormSchema = z.infer<typeof absenceFormSchema>;
